<div class="d-flex flex-row align-items-center justify-content-center h-100 container">
    <div class="col-1 w-50">
        <div class="open-form">
            <div class="row d-flex justify-content-left text-mobile">
                <h1 class="accent text-left m-h1 line-height-h1">{{ 'b2c.IDS_TITLE_REJECT' | translate }}</h1>
            </div>
            <div class="row d-flex justify-content-left text-mobile">
                <h4 class="font-weight-normal m-0 text-left line-height-h4"
                    [innerHTML]="'b2c.IDS_SUBTITLE_REJECT' | translate"></h4>
            </div>

            <div class="row d-flex justify-content-left text-mobile input-top-margin">
                <h4 class="font-weight-normal m-0 text-left line-height-h4 m-b-quotation-number"
                    [innerHTML]="'b2c.IDS_QUOTATION_NUMBER' | translate"></h4>
            </div>
            <form class="row d-flex justify-content-center" [formGroup]="formGroup">
                <mat-form-field appearance="none" color="accent" class="inputUUID">
                    <input matInput class="form-control" formControlName="UUIDField" type="text"
                        placeholder="00000-00000" [errorStateMatcher]="" [(ngModel)]=uuid minLength="13" maxlength="13"
                        name="UUIDField" [unmask]="true" [imask]="customMask" (ngModelChange)="onFocusOutEvent()"  [readonly]="true">
                    <div *ngIf="formGroup && formGroup.get('UUIDField').touched && formGroup.get('UUIDField').invalid"
                        class="uuid-error" [innerHTML]="'b2c.IDS_UUID_REQUIRED' | translate"></div>
                    <div *ngIf="formGroup && formGroup.get('UUIDField').valid && !validUuid" class="uuid-error"
                        [innerHTML]="'b2c.IDS_UUID_INCORRECT' | translate"></div>
                </mat-form-field>
            </form>

            <div class="row d-flex justify-content-center button-margin button-mobile">
                <button mat-flat-button color="primary" class="cta"
                    [eventTracker]='{"category":"quote_reject", "label":"quote_reject", "action":"click"}'(click)='btnRifiuta()'
                    [disabled]="(formGroup && formGroup.get('UUIDField').invalid) || (!validUuid || !loaded)">
                    <span class="text-uppercase">
                        {{ 'b2c.IDS_RIFIUTA' | translate }}
                    </span>
                </button>
            </div>

        </div>
    </div>

    <div class="col-2 w-50">
        <div class="imagecontainer">
        </div>
    </div>

</div>
<!--
<app-lateral-panel id="{{lateralPanelId}}" class="subtitle-info-lateral secondary" [extraClasses]="'summary m-w-768'"
    [(showSidebar)]="showSidebar">
    <div class="row d-flex justify-content-between align-items-center button-row exit-row panel-title">
        <h3 class="primary m-b-question m-t-question">{{'b2c.IDS_FIND_QUOTATION_NUMBER' | translate}}</h3>
        <button mat-flat-button class="bticino-ico close round-button-with-background transparent-background"
            style="width: 40px; height: 40px" (click)="onCloseTooltip()">
        </button>
    </div>
    <p class="primary m-b-32 p-r-29 m-t-0 p-y panel-description"
        [innerHTML]="'b2c.IDS_FIND_QUOTATION_NUMBER_DESCR' | translate"></p>
    <div class="lateral-panel-media">
        <img [src]="lateralPanelImage" class="lateral-panel-image">
    </div>
</app-lateral-panel> -->